import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POISledgeTrackStateFields from "@/components/POI/POIStateFields/POISledgeTrackStateFields/POISledgeTrackStateFields.vue";

export default {
  components: { POIStep, POISledgeTrackStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
